import { cB as c, cM as r, cE as o, cNotM as e, c as a } from "./ghl-ui.es384.js";
const i = c("tag", `
 --n-close-margin: var(--n-close-margin-top) var(--n-close-margin-right) var(--n-close-margin-bottom) var(--n-close-margin-left);
 white-space: nowrap;
 position: relative;
 box-sizing: border-box;
 cursor: default;
 display: inline-flex;
 align-items: center;
 flex-wrap: nowrap;
 padding: var(--n-padding);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 line-height: 1;
 height: var(--n-height);
 font-size: var(--n-font-size);
`, [r("strong", `
 font-weight: var(--n-font-weight-strong);
 `), o("border", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 border: var(--n-border);
 transition: border-color .3s var(--n-bezier);
 `), o("icon", `
 display: flex;
 margin: 0 4px 0 0;
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 font-size: var(--n-avatar-size-override);
 `), o("avatar", `
 display: flex;
 margin: 0 6px 0 0;
 `), o("close", `
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `), r("round", `
 padding: 0 calc(var(--n-height) / 3);
 border-radius: calc(var(--n-height) / 2);
 `, [o("icon", `
 margin: 0 4px 0 calc((var(--n-height) - 8px) / -2);
 `), o("avatar", `
 margin: 0 6px 0 calc((var(--n-height) - 8px) / -2);
 `), r("closable", `
 padding: 0 calc(var(--n-height) / 4) 0 calc(var(--n-height) / 3);
 `)]), r("icon, avatar", [r("round", `
 padding: 0 calc(var(--n-height) / 3) 0 calc(var(--n-height) / 2);
 `)]), r("disabled", `
 cursor: not-allowed !important;
 opacity: var(--n-opacity-disabled);
 `), r("checkable", `
 cursor: pointer;
 box-shadow: none;
 color: var(--n-text-color-checkable);
 background-color: var(--n-color-checkable);
 `, [e("disabled", [a("&:hover", "background-color: var(--n-color-hover-checkable);", [e("checked", "color: var(--n-text-color-hover-checkable);")]), a("&:active", "background-color: var(--n-color-pressed-checkable);", [e("checked", "color: var(--n-text-color-pressed-checkable);")])]), r("checked", `
 color: var(--n-text-color-checked);
 background-color: var(--n-color-checked);
 `, [e("disabled", [a("&:hover", "background-color: var(--n-color-checked-hover);"), a("&:active", "background-color: var(--n-color-checked-pressed);")])])])]);
export {
  i as default
};
